import { generatePath } from 'react-router';

export const ServiceRequestDetailsPath = '/requests/:id';
export const GetServiceRequestDetailsPath = (serviceRequestId: number) =>
  generatePath(ServiceRequestDetailsPath, {
    id: serviceRequestId,
  });
